import React from "react";
import { object, oneOf, shape } from "prop-types";
import LinksBlock from "../Apps/components/LinksBlock";
import HeroBlock from "../Apps/components/HeroBlock";
import VisualCopyBlock from "../Apps/components/VisualCopyBlock";
import CopyBlock from "../Apps/components/CopyBlock";
import TestimonialsBlock from "../Apps/components/TestimonialsBlock";
import FeaturedContentBlock from "../Apps/components/FeaturedContentBlock";

const renderBlockByTypeFactory = (slug, components, contentReference) => {
	const renderBlockByType = ({ sys: { contentType, id }, fields }) => {
		// Don't show draft blocks
		if (!contentType) return null;

		const {
			sys: { id: type },
		} = contentType;

		const LinkSection = components?.linksBlock || LinksBlock;
		const VisualCopySection = components?.visualCopyBlock || VisualCopyBlock;
		const HeroBlockSection = components?.heroBlock || HeroBlock;
		const CopyBlockSection = components?.blockCopy || CopyBlock;
		const TestimonialsBlockSection = components?.testimonialsBlock || TestimonialsBlock;
		const FeaturedContentSection = components?.blockFeaturedContent || FeaturedContentBlock;
		const FormSection = components?.formBlock && fields?.formId ? components?.formBlock : null;

		switch (type) {
			case "blockLinks":
				return <LinkSection key={id} {...fields} />;
			case "blockHero":
				return <HeroBlockSection key={id} {...fields} contentReference={contentReference} />;
			case "blockVisualCopy":
				return <VisualCopySection key={id} {...fields} components={components} />;
			case "blockCopy":
				return <CopyBlockSection key={id} id={id} {...fields} components={components} />;
			case "blockTestimonials":
				return <TestimonialsBlockSection key={id} {...fields} components={components} />;
			case "blockFeaturedContent":
				return <FeaturedContentSection key={id} {...fields} components={components} slug={slug} />;
			case "blockForm":
				return <FormSection key={id} {...fields} />;
			default:
				return null;
		}
	};

	renderBlockByType.propTypes = {
		sys: shape({
			contentType: shape({
				sys: shape({
					id: oneOf([
						"blockLinks",
						"blockHero",
						"blockVisualCopy",
						"blockCopy",
						"blockTestimonials",
						"blockFeaturedContent",
						"blockForm",
					]),
				}),
			}),
		}),
		fields: object, // eslint-disable-line react/forbid-prop-types
	};

	return renderBlockByType;
};

export default renderBlockByTypeFactory;
